import React from "react";
import Moment from "react-moment";
import { useSelector } from 'react-redux';

function PatientInfo() {

    const patientData = useSelector((state) => state.patientDetails);
    //console.log(patientData)

    return (
        <div className="patientinfodiv position-relative">
            <div className={patientData.patientGender === '' ? 'patientImg male' : patientData.patientGender === 'male' ? 'patientImg male' : patientData.patientGender === 'female' ? 'patientImg female' : patientData.patientGender === 'other' ? 'patientImg male' : ''}></div>
            <h5 className="mb-0">{patientData?.patientFirstName} {patientData?.patientLastName}</h5>
            <p><span>{patientData.patientGender === '' ? '' : patientData.patientGender === 'male' ? '( M )' : patientData.patientGender === 'female' ? '( F )' : patientData.patientGender === 'other' ? '( O )' : ''} DOB <Moment format="MM/DD/YYYY">{patientData?.patientBirthdate}</Moment> </span></p>
        </div>
    )
}

export default PatientInfo;